query BusinessUnitsTableData(
  $days: Int!
  $customFieldsFilter: ConditionStringArray
  $customFieldsFilterExcludes: ConditionStringArray
) {
  # Web SDK Tests - Both critical and serious issues for all business units
  wsdkIssuesCount: wsdk_test_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: filtered_custom_fields
  ) {
    filtered_custom_fields(key:"unitId")
    critical_issues_sum
    serious_issues_sum
  }
  
  # WFA Sessions - Both critical and serious issues for all business units
  wfaIssuesCount: wfa_session_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: filtered_custom_fields
  ) {
    filtered_custom_fields(key:"unitId")
    critical_issues_sum
    serious_issues_sum
  }
}
